import clsx from "clsx"
import * as regex from "src/utils/regex"
import { useState } from "react"
import { UseFormMethods } from "react-hook-form"

type Props = {
  errors: UseFormMethods["errors"]
  register: UseFormMethods["register"]
  name?: string
}

const InputPassword: React.FC<Props> = ({
  errors,
  register,
  name = "password",
}) => {
  const [isText, setIsText] = useState(false)

  return (
    <>
      <div className="c-input-password">
        <i
          className="far fa-eye"
          onClick={() => {
            setIsText(!isText)
          }}
        ></i>
        <input
          className={clsx({
            "c-textfield-primary": true,
            password: true,
            "-error": errors[name],
          })}
          type={isText ? "text" : "password"}
          name={name}
          ref={register({
            required: true,
            pattern: regex.regPassword,
          })}
        />
      </div>
    </>
  )
}

export default InputPassword
